import { Star } from "lucide-react";

export const Stars = ({ value = 0, onChange, size = 16 }) => (
  <div className="flex gap-1" data-testid="stars">
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        disabled={!onChange}
        onClick={() => onChange?.(n)}
        data-testid={onChange ? `star-input-${n}` : undefined}
        className={onChange ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"}
      >
        <Star
          size={size}
          strokeWidth={1.5}
          className={n <= Math.round(value) ? "fill-[#C87455] text-[#C87455]" : "text-zinc-700"}
        />
      </button>
    ))}
  </div>
);
